import React from "react"
import { Link } from "react-router-dom"
import * as moment from "moment"

const CustId = cell => {
  return (
    <Link to="#" className="text-body fw-bold">
      {cell.value ? cell.value : ""}
    </Link>
  )
}

const ProfileName = cell => {
  return cell?.value ? (
    <div style={{ textAlign: "center" }}>{cell.value} </div>
  ) : (
    ""
  )
}

const Modifieddata = cell => {
  return cell ? formateDate(cell) : ""
}
const Modifieddatas = cell => {
  return cell ? formateDate(cell?.cell?.value) : ""
}

const formateDate = (date, format) => {
  const dateFormat = format ? format : "DD-MM-YYYY"
  const date1 = moment(date).format(dateFormat)
  return date1.toString()
}
const GridBoolValue = cell => {
  return cell && cell.value ? (
    <i className="mdi mdi-check-bold me-2 text-success " />
  ) : (
    <i className="mdi mdi-close-thick me-2 text-danger" />
  )
}
const GridbranchBoolValue = cell => {
  return cell && cell.value ? (
    <i className="mdi mdi-check-bold me-2 text-success " />
  ) : (
    <i className="mdi mdi-close-thick me-2 text-danger" />
  )
}
const TrackScreenResolution = cell => {
  return cell.value && cell.value === "L"
    ? "Low"
    : cell.value === "H"
    ? "High"
    : cell.value === "M"
    ? "Medium"
    : ""
}

export {
  CustId,
  ProfileName,
  GridBoolValue,
  TrackScreenResolution,
  Modifieddata,
  GridbranchBoolValue,
  Modifieddatas,
}
